const VERSION = '6.1.0'

export {VERSION}
